/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Entity list from protobuf EntityList message.
 * @export
 * @interface ControlEntityList
 */
export interface ControlEntityList {
    /**
     * 
     * @type {number}
     * @memberof ControlEntityList
     */
    entity_type: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlEntityList
     */
    entity_ids: Array<string>;
}

/**
 * Check if a given object implements the ControlEntityList interface.
 */
export function instanceOfControlEntityList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "entity_type" in value;
    isInstance = isInstance && "entity_ids" in value;

    return isInstance;
}

export function ControlEntityListFromJSON(json: any): ControlEntityList {
    return ControlEntityListFromJSONTyped(json, false);
}

export function ControlEntityListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_type': json['entity_type'],
        'entity_ids': json['entity_ids'],
    };
}

export function ControlEntityListToJSON(value?: ControlEntityList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_type': value.entity_type,
        'entity_ids': value.entity_ids,
    };
}

